import { useFormikContext } from 'formik';
import camelCase from 'lodash/camelCase';
import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Pagination } from 'semantic-ui-react';

import ProfileButton from '../../../assets/images/directory/profile_button.svg';

import { subscriber_profile_path } from '../../routes.js';
import { Spinner } from '../BaseUI';
import { MessageModal } from '../shared';

import { useQueryClient } from 'react-query';

import { useNavigate } from "react-router-dom";

const MAX_PAGES = 3;

const Subscribers = ({
  profiles,
  isLoadingSubscriberDirectory,
  totalPages,
  descriptionField,
  currentUserId,
}) => {
  const { values, setFieldValue } = useFormikContext();
  const [messageUser, setMessageUser] = useState(null);

  const handlePageChange = (_e, data) => {
    setFieldValue('page', data.activePage);
  };

  const queryClient = useQueryClient();

  const navigate = useNavigate();

  const profilesJSX = (profiles) => {
    if (profiles.length <= 0) {
      return <div className="profile-no-results">No Results Found!</div>;
    } else {
      return profiles.map((profile, i) => {
        return(
          <Row className="profile-container" key={profile.id}>
            <Col
              className="col-md-8 profile-info-wrapper"
              onClick={(e) => {
                e.preventDefault;
                navigate(subscriber_profile_path(profile.username));
              }}
            >
              <div className="avatar-container">
                {profile.picture ? (
                  <img src={profile.picture} />
                ) : (
                  <div className="avatar-placeholder">
                    <div className="avatar-name">{profile.subInitial}</div>
                  </div>
                )}
              </div>

              <div className="profile-details">
                <div className="name">{profile.name}</div>
                <div className="profile-detail">{profile.oneLineBio}</div>
                <div className="profile-detail">
                  <div className="title-company-wrapper">
                    {profile.titleAtCompany}
                    {profile.titleAtCompany && profile.companyName && (
                      <div className="dot-middle">.</div>
                    )}
                    {profile.companyName}
                  </div>
                </div>
                {descriptionField && profile[camelCase(`${descriptionField}_desc`)] && (
                  <div className="profile-detail">
                    {profile[camelCase(`${descriptionField}_desc`)]}
                  </div>
                )}

                <div className="mobile-view-profile">
                  <div className="action-container">
                    {profile.canSendMessage && profile.id !== currentUserId && (
                      <button className="send-message-btn" onClick={() => setMessageUser(profile)}>
                        Message
                        <img src={ProfileButton} />
                      </button>
                    )}
                    <div>
                      <h1>Link</h1>
                      <a href={subscriber_profile_path(profile.username)}>View Profile</a>
                      <img src={ProfileButton} />
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col className="col-md-4 view-profile">
              <div className="action-container">
                {profile.canSendMessage && profile.id !== currentUserId && (
                  <button className="send-message-btn" onClick={() => setMessageUser(profile)}>
                    Message
                    <img src={ProfileButton} />
                  </button>
                )}
                <div>
                  <a href={subscriber_profile_path(profile.username)}>View Profile</a>
                  <img src={ProfileButton} />
                </div>
              </div>
            </Col>
          </Row>
        )
      });
    }
  };

  const isFirstPage = values.page === 1;
  const isLastPage = values.page >= totalPages || values.page >= MAX_PAGES;
  return (
    <div className="list-wrapper">
      {isLoadingSubscriberDirectory ? (
        <Spinner />
      ) : (
        <>
          {profilesJSX(profiles)}
          <MessageModal user={messageUser} onClose={() => setMessageUser(null)} />
        </>
      )}
      <React.Fragment key={values.page}>
        {!isLoadingSubscriberDirectory && totalPages > 1 && (
          // Pagination arrows can be custom!
          // *If undefined the default will be used, if null there will be no arrow at all
          <Pagination
            defaultActivePage={values.page}
            firstItem={isFirstPage ? null : undefined} // see note above
            nextItem={isLastPage ? null : undefined} // see note above
            prevItem={isFirstPage ? null : undefined} // see note above
            lastItem={isLastPage ? null : undefined} // see note above
            onPageChange={handlePageChange}
            size="mini"
            siblingRange={0}
            totalPages={totalPages <= MAX_PAGES ? totalPages : MAX_PAGES}
          />
        )}
      </React.Fragment>
    </div>
  );
};

export default Subscribers;
